if (!customElements.get('variant-price-updater')) {
  customElements.define(
    'variant-price-updater',
    class VariantPriceUpdater extends HTMLElement {
      constructor() {
        super();
        
        this.variantSelects = document.querySelector('variant-selects');
        this.productForm = document.querySelector(`#product-form-${this.dataset.section}`);
        this.variantJson = this.getVariantData();
        
        // Debug info
        console.log('VariantPriceUpdater initialized');
        console.log('Product JSON:', this.variantJson);
        
        if (this.variantSelects) {
          this.setupPriceUpdateListener();
          // Initial update - with slight delay to ensure DOM is ready
          setTimeout(() => {
            this.updateVariantPrices();
          }, 300);
        }
      }
      
      setupPriceUpdateListener() {
        // Listen for option selections
        this.variantSelects.addEventListener('change', (event) => {
          setTimeout(() => {
            this.updateVariantPrices();
          }, 100);
        });
        
        // Listen for variant changes
        document.addEventListener('variant:changed', (event) => {
          this.updateVariantPrices();
        });
      }
      
      getVariantData() {
        // Find the product JSON data
        const productJson = document.getElementById(`ProductJson-${this.dataset.section}`);
        if (!productJson) {
          console.error('Product JSON element not found');
          return [];
        }
        
        try {
          const data = JSON.parse(productJson.textContent);
          if (data && data.variants && Array.isArray(data.variants)) {
            console.log('Found variants:', data.variants.length);
            return data.variants;
          } else {
            console.error('Variants not found in product data');
            return [];
          }
        } catch (e) {
          console.error("Error parsing product JSON:", e);
          return [];
        }
      }
      
      getSelectedOptions() {
        const selectedOptions = [];
        const optionSelectors = this.variantSelects.querySelectorAll('.product-form__input');
        
        optionSelectors.forEach((selector, index) => {
          // Check if it's radio buttons or dropdown
          const selectedInput = selector.querySelector('input:checked, select option:checked');
          if (selectedInput) {
            selectedOptions[index] = selectedInput.value;
          }
        });
        
        return selectedOptions;
      }
      
      findMatchingVariantPrice(optionPosition, optionValue) {
        // Check if variants array is valid
        if (!this.variantJson || !Array.isArray(this.variantJson) || this.variantJson.length === 0) {
          console.error('Invalid variants data:', this.variantJson);
          return null;
        }
        
        // Get current selected options
        const selectedOptions = this.getSelectedOptions();
        
        // Create a test options array where we'll simulate selecting the 
        // option we're currently pricing
        const testOptions = [...selectedOptions];
        testOptions[optionPosition - 1] = optionValue;
        
        // Look for a variant that matches these test options
        for (let i = 0; i < this.variantJson.length; i++) {
          const variant = this.variantJson[i];
          
          // Check if this variant matches all our test options
          let optionsMatch = true;
          for (let j = 0; j < testOptions.length; j++) {
            if (variant.options[j] !== testOptions[j]) {
              optionsMatch = false;
              break;
            }
          }
          
          if (optionsMatch) {
            return {
              price: variant.price,
              available: variant.available
            };
          }
        }
        
        // If no exact match, return null
        return null;
      }
      
      updateVariantPrices() {
        // Get all price spans
        const priceElements = document.querySelectorAll('.variant-price');
        console.log('Found price elements:', priceElements.length);
        
        // Update each variant price element
        priceElements.forEach(element => {
          const optionPosition = parseInt(element.getAttribute('data-option-position'), 10);
          const optionValue = element.getAttribute('data-value');
          
          console.log('Updating price for:', optionPosition, optionValue);
          
          // Find price for this specific option
          const variantInfo = this.findMatchingVariantPrice(optionPosition, optionValue);
          
          if (variantInfo) {
            // Display price
            element.textContent = this.formatMoney(variantInfo.price);
            
            // Add visual indication if variant is unavailable
            if (!variantInfo.available) {
              element.classList.add('unavailable');
              element.closest('label').classList.add('sold-out');
            } else {
              element.classList.remove('unavailable');
              element.closest('label').classList.remove('sold-out');
            }
          } else {
            element.textContent = 'Unavailable';
            element.classList.add('unavailable');
            element.closest('label').classList.add('sold-out');
          }
        });
      }
      
      formatMoney(cents) {
        if (typeof Shopify !== 'undefined' && Shopify.formatMoney) {
          return Shopify.formatMoney(cents);
        }
        
        // Fallback formatter if Shopify.formatMoney isn't available
        const value = parseInt(cents, 10) / 100;
        return '$' + value.toFixed(2);
      }
    }
  );
} 